import { render, staticRenderFns } from "./DmqFilters.vue?vue&type=template&id=022c5e4c&"
import script from "./DmqFilters.vue?vue&type=script&lang=ts&"
export * from "./DmqFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports